import { render } from "./card5.vue?vue&type=template&id=3265798d&scoped=true"
import script from "./card5.vue?vue&type=script&lang=js"
export * from "./card5.vue?vue&type=script&lang=js"

import "./card5.vue?vue&type=style&index=0&id=3265798d&scoped=true&lang=css"

import exportComponent from "/Users/jiangxin/xhw/outer-h5-gwj-nft-website-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3265798d"]])

export default __exports__